export const determineVotes = (votes, phases) => {

    let returnedVotes = -1;
    if(votes != null && phases?.votingStarted){
        returnedVotes = votes;
    }
    return returnedVotes;
}
